export enum QueryStringPrimaryKeys {
	SEARCH = "query",
	PAGE = "page",
	SHOW_NUMBER_PRODUCTS = "number-products",
}
